export const GET_IDENTITY_BY_EMAIL = `
    MATCH (i:Identity)
    WHERE  i.email = $email
    RETURN i
`;

export const GET_IDENTITY_BY_ID = `
    MATCH (i:Identity)
    WHERE  i.id = $identityId
    RETURN i
`;

export const GET_PROFILE_BY_TYPE_AND_IDENTITY_ID = `
    MATCH (i:Identity)-[:HAS_PROFILE]->(p:Profile)
    WHERE i.id = $identityId 
    AND p.profileType = $profileType
    RETURN p
`;

export const CREATE_ABACUS_PROFILE = `
    MATCH (v:Vendor {id: "*"})
    MATCH (i:Identity)
        WHERE i.id = $identityId
    MERGE (increment:IncrementId {nodeName: 'Profile'})
        ON CREATE SET increment.id = 2
        ON MATCH SET increment.id = increment.id + 1
    CREATE (p:Profile {
        profileId: (increment.id-1),
        profileType: 'AbacusProfile',
        profileName: i.name,
        uuid: apoc.create.uuid(),
        roles: ['administrator'],
        fullCatalogAccess: true,
        brand: 'orchard',
        createdAt: datetime(),
        lastModifiedAt: datetime(),
        createdBy: $createdBy,
        lastModifiedBy: $createdBy
    })
    MERGE (i)-[:HAS_PROFILE]->(p)
    MERGE (p)-[:HAS_ACCESS_TO]->(v)
    RETURN p
`;
